"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var getHexColor_1 = require("../../services/getHexColor");
var SIZE = 50;
var ProgressSpinner = /** @class */ (function (_super) {
    __extends(ProgressSpinner, _super);
    function ProgressSpinner(props) {
        var _this = _super.call(this, props) || this;
        _this.rootProps = {};
        _this.circleStyle = {};
        _this.getRelativeValue = function (value, min, max) {
            var clampedValue = Math.min(Math.max(min, value), max);
            return (clampedValue - min) / (max - min);
        };
        _this.calculateDeterminateStyles = function (props) {
            var mode = props.mode, value = props.value, min = props.min, max = props.max;
            if (mode === 'determinate') {
                var relVal = _this.getRelativeValue(value, min, max) * 100;
                var circumference = 2 * Math.PI * (SIZE / 2 - 5);
                _this.circleStyle.strokeDashoffset = Math.round((100 - relVal) / 100 * circumference * 1000) / 1000 + "px";
                _this.circleStyle.strokeDasharray = Math.round(circumference * 1000) / 1000;
                _this.rootProps['aria-valuenow'] = value;
                _this.rootProps['aria-valuemin'] = min;
                _this.rootProps['aria-valuemax'] = max;
            }
        };
        _this.calculateDeterminateStyles(props);
        return _this;
    }
    ProgressSpinner.prototype.componentWillReceiveProps = function (nextProps) {
        this.calculateDeterminateStyles(nextProps);
    };
    ProgressSpinner.prototype.render = function () {
        var _a = this.props, classes = _a.classes, className = _a.className, colorString = _a.color, sizeProp = _a.size, style = _a.style, thickness = _a.thickness, mode = _a.mode, value = _a.value, min = _a.min, max = _a.max, other = __rest(_a, ["classes", "className", "color", "size", "style", "thickness", "mode", "value", "min", "max"]);
        var svgClasses = classNames({
            'progress-spinner__svg--indeterminate': mode === 'indeterminate',
            'progress-spinner__svg--determinate': mode === 'determinate'
        });
        var circleClasses = classNames('progress-spinner__circle', {
            'progress-spinner__circle--indeterminate': mode === 'indeterminate'
        });
        var size;
        switch (sizeProp) {
            case 'extra-small':
                size = 20;
                break;
            case 'small':
                size = 30;
                break;
            case 'medium':
                size = 50;
                break;
            case 'large':
                size = 75;
                break;
            default:
                size = sizeProp;
        }
        var color = getHexColor_1.default(colorString);
        return (React.createElement("div", __assign({ className: classNames('progress-spinner__root', className), style: __assign({ width: size, height: size, color: color }, style) }, this.rootProps, other),
            React.createElement("svg", { className: svgClasses, viewBox: "0 0 " + SIZE + " " + SIZE },
                React.createElement("circle", { className: circleClasses, style: this.circleStyle, cx: SIZE / 2, cy: SIZE / 2, r: SIZE / 2 - 5, fill: "none", strokeWidth: thickness }))));
    };
    ProgressSpinner.defaultProps = {
        color: getHexColor_1.default('action'),
        size: 40,
        thickness: 3.6,
        mode: 'indeterminate',
        value: 0,
        min: 0,
        max: 100
    };
    return ProgressSpinner;
}(React.Component));
exports.default = ProgressSpinner;
//# sourceMappingURL=ProgressSpinner.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/ProgressSpinner/ProgressSpinner.js
// module id = 60
// module chunks = 0